/* unplugin-vue-components disabled */import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=00ed347d&lang=scss"

const __exports__ = script;

export default __exports__